module.exports = __webpack_public_path__ + "img/icon-footer-close.a4e8a79b.png";